import { Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import Loader from '../../../common/loader/Loader'
import { MarketWastagesAmountAndVolumes } from '../../../common/marketSales/types'
import MarketWastageTable from '../../../common/monthlyWeeklyInfo/MarketWastageTable'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index'
import css from '../monthlyInfoPage.css'
import { fetchMonthlyInfoMarketWastages } from '../monthlyInfoQueries'

interface Props {
  stationId: string
  date: string
}

interface QueryResponse {
  monthlyInfoMarketWastages?: MarketWastagesAmountAndVolumes[]
}

interface QueryVariables {
  date: string
  stationId: string
}

const freshProductCdtLevel2Ids = ['CAAAA', 'CAAAW', 'CAAAE']

export default function MonthlyMarketWastages({ date, stationId }: Props) {
  return (
    <Query<QueryResponse, QueryVariables> query={fetchMonthlyInfoMarketWastages} variables={{ date, stationId }}>
      {({ data, loading, error }) => (
        <Loader {...{ loading, error }}>
          <div className={css.salesAndHours}>
            <Typography variant='h6' gutterBottom>
              {i18n.t('monthlyInfo.title.marketWastage', {
                month: moment(date).format('MMMM'),
              })}
            </Typography>
            <MarketWastageTable
              marketWastages={data.monthlyInfoMarketWastages}
              isMonthlyInfo={true}
              date={date}
              stationId={stationId}
            />
          </div>
        </Loader>
      )}
    </Query>
  )
}
